/* eslint-disable eslint-comments/no-restricted-disable */
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';

type HelpCenterSettingsCustomerNotificationsAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const helpCenterSettingsCustomerNotificationsAppEntryPoint: EntryPoint<
	HelpCenterSettingsCustomerNotificationsAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsCustomerNotificationsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-customer-notifications-app" */ './ExportedComponent.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
